import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { FormProperty } from '@common/components/app-control/app-control.component';
import { ToggleGroupItem } from '@common/components/toggle-group/toggle-group.component';
import { ColumnSettings } from '@common/interfaces/column-settings.interface';
import { TicketActiveCellComponent } from './components/ticket-active-cell.component';
import { TicketBaseModel } from './models/ticket-base.model';
import { TicketListModel } from './models/ticket-list.model';

export const ticketBaseColumns: ColumnSettings<keyof TicketBaseModel>[] = [
    { field: 'customerId', title: 'Customer', type: 'codelist', codelistName: 'Customer', codelistNameOnly: true },
    {
        field: 'invoiceNumber',
        title: 'Invoice',
        customRoute: { path: '/invoice', field: 'invoiceId' },
        isLink: true
    },
    {
        field: 'active',
        title: 'Active',
        templateComponent: TicketActiveCellComponent,
        templateInputs: (row) => ({
            active: row.active,
            remark: row.remark
        })
    },
    { field: 'description', title: 'Description', type: 'textarea' },
    {
        field: 'tariffTypeId',
        title: 'Tariff Type',
        type: 'codelist',
        codelistNameOnly: true,
        codelistName: 'TariffType'
    },
    { field: 'serviceId', title: 'Service', type: 'codelist', codelistName: 'Service', hasCodelistPrefix: true },
    {
        field: 'unitOfMeasurementId',
        title: 'Unit of Measurement',
        type: 'codelist',
        codelistNameOnly: true,
        codelistName: 'UnitOfMeasurement'
    },
    { field: 'from', title: 'From', type: 'number', format: 'n2' },
    { field: 'to', title: 'To', type: 'number', format: 'n2' },
    { field: 'quantity', title: 'Quantity', type: 'number', format: 'n3' },
    { field: 'quantity2', title: 'Quantity 2', type: 'number', format: 'n3' },
    {
        field: 'pricePerUnit',
        title: 'Price per Unit',
        type: 'number',
        format: {
            maximumFractionDigits: 4
        },
        currency: true,
        currencyField: 'currencyId'
    },
    {
        field: 'surcharge',
        title: marker('Rebate'),
        type: 'number',
        format: 'percent',
        width: 80
    },
    {
        field: 'taxId',
        title: marker('VAT Amount (%)'),
        type: 'codelist',
        codelistName: 'Tax',
        codelistFull: true,
        width: 140
    },
    {
        field: 'total',
        title: 'Total',
        type: 'number',
        currency: true,
        currencyField: 'currencyId'
    },
    {
        field: 'startDate',
        title: 'Start Date',
        type: 'datetime'
    },
    {
        field: 'endDate',
        title: 'End Date',
        type: 'datetime'
    },
    {
        field: 'createdDate',
        title: 'Created Date',
        type: 'datetime'
    }
];

export const ticketListColumns: ColumnSettings<keyof TicketListModel>[] = [
    {
        field: 'reference',
        title: 'Reference',
        isLink: true
        // custom path is overriden later
    },
    ...ticketBaseColumns
];

export const getTicketFilterProperties = (filter: any, activeTab: number): FormProperty[] => [
    {
        name: 'serviceId',
        label: 'Service',
        type: 'codelist',
        codelist: 'Service',
        colSpan: 2,
        initialValue: filter?.serviceId
    },
    {
        name: 'customerId',
        label: 'Customer',
        type: 'codelist',
        codelist: 'Customer',
        colSpan: 2,
        initialValue: filter?.customerId
    },
    {
        name: 'tariffTypeId',
        label: 'Tariff Type',
        type: 'codelist',
        codelist: 'TariffType',
        colSpan: 2,
        initialValue: filter?.tariffTypeId
    },
    {
        name: 'startDate',
        label: 'Start Date',
        type: 'date',
        colSpan: 2,
        initialValue: filter?.startDate
    },
    {
        name: 'endDate',
        label: 'End Date',
        type: 'date',
        colSpan: 2,
        initialValue: filter?.endDate
    },
    activeTab != 3
        ? {
              name: 'vesselName',
              label: 'Vessel Name',
              type: 'string',
              colSpan: 2,
              initialValue: filter?.vesselName
          }
        : {
              name: 'meterPositionId',
              label: 'Meter Position',
              type: 'codelist',
              codelist: 'MeterPosition',
              colSpan: 2,
              initialValue: filter?.meterPositionId
          }
];

export const ticketQuickFilters: ToggleGroupItem[] = [
    {
        icon: 'faSolidFerry',
        tooltip: 'Shore usage fees (except Omišalj)',
        value: '01'
    },
    {
        icon: 'faSolidShip',
        tooltip: 'Shore usage fees - Omišalj',
        value: '02'
    },
    {
        icon: 'faSolidAnchor',
        tooltip: 'Ship berthing fees',
        value: '03'
    },
    {
        icon: 'faSolidSailboat',
        tooltip: 'Mooring fees',
        value: '05'
    },
    {
        icon: 'faSolidPaste',
        tooltip: 'Declaration forms, labels, etc.',
        value: '14'
    },
    {
        icon: 'faSolidShield',
        tooltip: 'Terminal security charge',
        value: '17'
    },
    {
        icon: 'faSolidBolt',
        tooltip: 'Pre-invoiced electricity costs',
        value: 'TS'
    },
    {
        icon: 'faSolidWaterLadder',
        tooltip: 'Pre-invoiced water costs',
        value: 'TV'
    },
    {
        icon: 'faSolidTrash',
        tooltip: 'Waste reception – indirect fee',
        value: '20'
    }
];
